module.exports = __webpack_public_path__ + "img/error_ling.fca1248d.gif";